import PropTypes from "prop-types";
import Card from "../../components/Cards/Card";
import NativeObject from "../../components/NativeObject/NativeObject";

function DeceptionMobile({ app, config }) {
  const { container } = config.deception;

  return (
    <div className="app deception">
      <div className="appContent">
        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            height: "100%",
            paddingBottom: "-40px",
          }}
        >
          <Card
            expandable
            exportTable
            app={app}
            exportContainer
            exportTableId={container[0].cards[0].nativeObject.id}
            header={{
              hardTitle: container[0].cards[0].title.hardTitle,
            }}
            style={{
              width: "100%",
              alignItems: "center",
              height: "50%",
            }}
          >
            <NativeObject
              app={app}
              key={container[0].cards[0].nativeObject.id}
              reference={{
                id: container[0].cards[0].nativeObject.id,
              }}
              style={{ marginTop: "20px" }}
            />
          </Card>
        </div>
        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            height: "100%",
            paddingBottom: "20px",
          }}
        >
          <Card
            expandable
            exportTable
            app={app}
            exportContainer
            exportTableId={container[1].cards[0].nativeObject.id}
            header={{
              hardTitle: container[1].cards[0].title.hardTitle,
            }}
            style={{
              width: "100%",
              alignItems: "center",
              height: "50%",
            }}
          >
            <NativeObject
              app={app}
              key={container[1].cards[0].nativeObject.id}
              reference={{
                id: container[1].cards[0].nativeObject.id,
              }}
              style={{ marginTop: "20px" }}
            />
          </Card>
        </div>
      </div>
    </div>
  );
}

DeceptionMobile.defaultProps = {
  app: null,
  config: {},
};

DeceptionMobile.propTypes = {
  app: PropTypes.object,
  config: PropTypes.object,
};

export default DeceptionMobile;
